const salesOverviewData = [
    {
        dayOfWeek: 'Mon',
        totalSales: 30487,
        totalOrders: 9870,
    },
    {
        dayOfWeek: 'Tue',
        totalSales: 24361,
        totalOrders: 11009,
    },
    {
        dayOfWeek: 'Wed',
        totalSales: 21002,
        totalOrders: 7801,
    },
    {
        dayOfWeek: 'Thu',
        totalSales: 19820,
        totalOrders: 6521,
    },
    {
        dayOfWeek: 'Fri',
        totalSales: 22909,
        totalOrders: 7546,
    },
    {
        dayOfWeek: 'Sat',
        totalSales: 32022,
        totalOrders: 12908,
    },
    {
        dayOfWeek: 'Sun',
        totalSales: 36790,
        totalOrders: 11230,
    },
];

const purchaseRatio = [
    {
        dayOfWeek: 'Mon',
        purchases: 487,
        storeViews: 9870,
    },
    {
        dayOfWeek: 'Tue',
        purchases: 4361,
        storeViews: 11009,
    },
    {
        dayOfWeek: 'Wed',
        purchases: 1002,
        storeViews: 7801,
    },
    {
        dayOfWeek: 'Thu',
        purchases: 1820,
        storeViews: 6521,
    },
    {
        dayOfWeek: 'Fri',
        purchases: 2909,
        storeViews: 7546,
    },
    {
        dayOfWeek: 'Sat',
        purchases: 2022,
        storeViews: 12908,
    },
    {
        dayOfWeek: 'Sun',
        purchases: 6790,
        storeViews: 11230,
    },
];

const aggregatedSellThroughRate = [
    {
        name: '1 Mar',
        percentage: 40,
    },
    {
        name: '3 Mar',
        percentage: 55,
    },
    {
        name: '5 Mar',
        percentage: 51,
    },
    {
        name: '7 Mar',
        percentage: 44,
    },
    {
        name: '9 Mar',
        percentage: 57,
    },
    {
        name: '11 Mar',
        percentage: 61,
    },
    {
        name: '13 Mar',
        percentage: 63,
    },
    {
        name: '15 Mar',
        percentage: 65,
    },
    {
        name: '17 Mar',
        percentage: 54,
    },
    {
        name: '19 Mar',
        percentage: 50,
    },
    {
        name: '21 Mar',
        percentage: 40,
    },
    {
        name: '23 Mar',
        percentage: 37,
    },
    {
        name: '25 Mar',
        percentage: 51,
    },
    {
        name: '27 Mar',
        percentage: 53,
    },
    {
        name: '29 Mar',
        percentage: 48,
    },
];

const returnRatio = [
    {
        name: 'Page A',
        uv: 40,
        pv: 24,
    },
    {
        name: 'Page B',
        uv: 30,
        pv: 13,
    },
    {
        name: 'Page C',
        uv: 20,
        pv: 68,
    },
    {
        name: 'Page D',
        uv: 27,
        pv: 39,
    },
    {
        name: 'Page E',
        uv: 18,
        pv: 48,
    },
    {
        name: 'Page F',
        uv: 23,
        pv: 38,
    },
    {
        name: 'Page G',
        uv: 34,
        pv: 43,
    },
];

const aggregatedSalesVelocity = [
    {
        name: '1 Mar',
        uv: 1750,
    },
    {
        name: '3 Mar',
        uv: 1750,
    },
    {
        name: '5 Mar',
        uv: 1750,
    },
    {
        name: '7 Mar',
        uv: 1750,
    },
    {
        name: '9 Mar',
        uv: 1750,
    },
    {
        name: '11 Mar',
        uv: 1750,
    },
    {
        name: '13 Mar',
        uv: 1750,
    },
    {
        name: '15 Mar',
        uv: 1750,
    },
    {
        name: '17 Mar',
        uv: 1750,
    },
    {
        name: '19 Mar',
        uv: 1750,
    },
    {
        name: '21 Mar',
        uv: 1750,
    },
    {
        name: '23 Mar',
        uv: 1750,
    },
    {
        name: '25 Mar',
        uv: 1750,
    },
    {
        name: '27 Mar',
        uv: 1750,
    },
    {
        name: '29 Mar',
        uv: 1750,
    },
];

const revenueGenerated = [
    {
        name: 'Page A',
        uv: 1000,
    },
    {
        name: 'Page B',
        uv: 5000,
    },
    {
        name: 'Page C',
        uv: 20000,
    },
    {
        name: 'Page D',
        uv: 27000,
    },
];

const salesByCategory = [
    { name: 'Men clothing', value: 800 },
    { name: 'Footwear', value: 300 },
    { name: 'Fashion Accessories', value: 300 },
    { name: 'Women Clothing', value: 200 },
    { name: 'Handbags', value: 50 },
];

const agedInventory = [
    { name: '0-3 months', value: 32 },
    { name: '3-6 months', value: 16 },
    { name: '6-12 months', value: 8 },
    { name: 'Over 12 months', value: 2 },
];

const salesByCustomCollection = [
    { name: 'New Arrivals', value: 800 },
    { name: 'Footwear', value: 300 },
    { name: 'New Collection', value: 300 },
    { name: '50% Off on Jeans', value: 200 },
    { name: 'Buy 1 Get 1', value: 50 },
];

const productReviews = [
    {
        name: 'Excellent reviews',
        percentage: 37.5,
    },
    {
        name: 'Fair Reviews',
        percentage: 57.5,
    },
    {
        name: 'Need Improvement',
        percentage: 20,
    },
];

const salesGeneratedUsingCoupon = [
    {
        date: '1 Mar',
        totalSales: 30487,
        totalOrders: 9870,
    },
    {
        date: '3 Mar',
        totalSales: 24361,
        totalOrders: 11009,
    },
    {
        date: '5 Mar',
        totalSales: 21002,
        totalOrders: 7801,
    },
    {
        date: '7 Mar',
        totalSales: 19820,
        totalOrders: 6521,
    },
    {
        date: '9 Mar',
        totalSales: 22909,
        totalOrders: 7546,
    },
    {
        date: '11 Mar',
        totalSales: 32022,
        totalOrders: 12908,
    },
    {
        date: '13 Mar',
        totalSales: 36790,
        totalOrders: 11230,
    },
];

const customerAcquisition = [
    {
        name: 'New Customer',
        value: 73,
    },
    {
        name: 'Returned Customer',
        value: 21
    },
];

const topCities = [
    {
        id: 1,
        title: 'Delhi',
        percentage: 56,
    },
    {
        id: 2,
        title: 'Nagercoil',
        percentage: 48
    },
    {
        id: 3,
        title: 'Mumbai',
        percentage: 43
    },
    {
        id: 4,
        title: 'Kochi',
        percentage: 38
    },
];

const topAgeRanges = [
    {
        id: 1,
        title: '18-24',
        percentage: 56
    },
    {
        id: 2,
        title: '25-34',
        percentage: 48
    },
    {
        id: 3,
        title: '35-44',
        percentage: 43
    },
    {
        id: 4,
        title: '45-54',
        percentage: 38
    },
];

const genderRatio = [
    {
        name: 'Male',
        percentage: 47
    },
    {
        name: 'Female',
        percentage: 53
    }
];

export {    
    salesOverviewData,
    salesByCategory,
    salesByCustomCollection,
    purchaseRatio,
    returnRatio,
    revenueGenerated,

    agedInventory,
    aggregatedSalesVelocity,
    aggregatedSellThroughRate,
    productReviews,
    salesGeneratedUsingCoupon,
    customerAcquisition,

    topCities,
    topAgeRanges,
    genderRatio,
};
